<div (click)="switchTheme()">
  <i class="fa fa-sun-o" *ngIf='accountService.themeMode' aria-hidden="true"></i>
  <i class="fa fa-moon-o" *ngIf='!accountService.themeMode' aria-hidden="true"></i>
</div>